import React, {useEffect, StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import 'regenerator-runtime/runtime'
import 'react-circular-progressbar/dist/styles.css'
import 'react-loading-skeleton/dist/skeleton.css'
import '@/lib/polyfill'
import {setupChunkErrorRecovery} from '@/lib/chunk-error-recovery'
import App from '@/app'
import {LoadComponent} from '@components/lazy-loader'

setupChunkErrorRecovery()
function AppWithCallbackAfterRender() {
  useEffect(() => {
    window.retracedPageLoaded = true
  }, [])

  return (
    <StrictMode>
      <React.Suspense fallback={<LoadComponent />}>
        <App />
      </React.Suspense>
    </StrictMode>
  )
}
const container = document.getElementById('root')
const root = createRoot(container)
root.render(<AppWithCallbackAfterRender />)
